<template>
  <div class="details">
    <div class="detailRow">
      <span class="detailLabel">DIALED</span>
      <span class="bucketRow">
        <span class="bucket">
          <span class="bucketCount">{{ counts['0'] }}</span>
          <span class="bucketLabel">0x</span>
        </span>
        <span class="bucket">
          <span class="bucketCount">{{ counts['1'] }}</span>
          <span class="bucketLabel">1x</span>
        </span>
        <span class="bucket">
          <span class="bucketCount">{{ counts['2'] }}</span>
          <span class="bucketLabel">2x</span>
        </span>
        <span class="bucket">
          <span class="bucketCount">{{ counts['3+'] }}</span>
          <span class="bucketLabel">3x+</span>
        </span>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  config: Record<string, any>
}>()

const counts = computed<Record<string, number>>(
  () => props.config.dial_counts || { '0': 0, '1': 0, '2': 0, '3+': 0 },
)
</script>

<style scoped>
.details {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.detailRow {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}
.detailLabel {
  font-family: var(--font-sans);
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--tracking-wide);
  color: var(--color-text-tertiary);
  flex-shrink: 0;
}
.bucketRow {
  display: flex;
  gap: var(--space-4);
}
.bucket {
  display: flex;
  align-items: baseline;
  gap: var(--space-1);
}
.bucketCount {
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  font-weight: var(--fw-semibold);
  color: var(--color-text-primary);
}
.bucketLabel {
  font-family: var(--font-sans);
  font-size: var(--fs-xs);
  color: var(--color-text-tertiary);
}
</style>
